import React from 'react';
import UserinfoPage from '../UserinfoPage/UserinfoPage';


const ProfilePage = () => {

    return (
        <div style={{backgroundColor: "#E9EAED", minHeight: "100vh"}}>
        <div className='py-5 container'>
            <UserinfoPage />
        </div>
        </div>
    );
}

export default ProfilePage;
